const initialState = {}

const appendedList = (partners, data) => {
  return [data, ...partners ]
}

const updatedList = (partners, data) => {
  const index = partners.findIndex(partner => partner.id == data.id)
  if (index == -1) return partners

  return [
    ...partners.slice(0, index), 
    data,
    ...partners.slice(index + 1, partners.length)
  ]
}

const releasedList = (partners, data) => {
  const index = partners.findIndex(partner => partner.id == data.id)
  if (index == -1) return partners

  return [
    ...partners.slice(0, index), 
    ...partners.slice(index + 1, partners.length)
  ]
}

const Partners = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'PARTNERS.INIT':
      return {...state, ...payload}
    case 'PARTNERS.CREATE':
      return {...state, partners: appendedList(state.partners, payload)}
    case 'PARTNERS.UPDATE':
      return {...state, partners: updatedList(state.partners, payload)}
    case 'PARTNERS.DELETE':
      return {...state, partners: releasedList(state.partners, payload)}
    default:
      return state
  }
}

export default Partners
